import { ProjectViewModel } from 'ShbDeployer/models/project';

angular.module('shbdeployer.app').factory('ProjectService', [
  '$q',
  '$http',
  'Project',
  'FileUploadService',
  function ProjectServiceFactory($q, $http, Project, FileUploadService) {
    'use strict';
    var service = {};

    service.project = function (id) {
      var deferred = $q.defer();
      Project.get({ id: id })
        .$promise.then(function success(data) {
          deferred.resolve(new ProjectViewModel(data));
        })
        .catch(function error(err) {
          deferred.reject({ msg: 'Не удалось получить проект', err: err });
        });
      return deferred.promise;
    };

    service.projects = function () {
      var deferred = $q.defer();
      Project.query({})
        .$promise.then(function success(data) {
          deferred.resolve(
            data.map(function map(item) {
              return new ProjectViewModel(item);
            })
          );
        })
        .catch(function error(err) {
          deferred.reject({ msg: 'Не удалось получить список проектов', err: err });
        });
      return deferred.promise;
    };

    service.status = function (id) {
      return Project.status({ id: id }).$promise;
    };

    service.nginxConfig = function (id) {
      return $http({ method: 'GET', url: 'api/projects/' + id + '/nginx-config', transformResponse: [angular.identity] }).then(function success(response) {
        return response.data;
      });
    };

    service.createProjectFromZipUpload = function (name, description, zipFile, endpointId) {
      return FileUploadService.createProject(name, description, zipFile, endpointId);
    };

    service.createProjectFromUrl = function (name, description, sourceUrl, endpointId) {
      return FileUploadService.createProjectFromUrl(name, description, sourceUrl, endpointId);
    };

    service.updateProject = function (id, name, description, zipFile, sourceUrl) {
      return FileUploadService.updateProject(id, name, description, zipFile, sourceUrl);
    };

    service.remove = function (id) {
      return Project.remove({ id: id }).$promise;
    };

    return service;
  },
]);
